import classNames from 'classnames';
import React from 'react';
import { LanguageSupportUtil } from 'utils/language_support_util';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import * as styles from './Link.module.scss';

type Props = {
  className?: string;
  color?: 'primary' | 'gray';
  href: string;
  onClick?: () => void;
  target?: '_blank';
};

function Link({ children, className, color = 'gray', href, onClick, target }: React.PropsWithChildren<Props>) {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <a
      className={classNames(color && styles[color], className)}
      href={LanguageSupportUtil.wrapUrlSafe(href, languageRegionCode)}
      onClick={onClick}
      {...(target ? { target } : {})}
    >
      {children}
    </a>
  );
}

export default Link;
